import React from 'react';

import { Paper } from '@mui/material';

import classes from './GeneralInfoRow.module.scss';
import { InfoCell } from './InfoCell/InfoCell';
import { CustomerGeneralInfo } from '../../../../../interfaces/PredefinedMealPlansInfo';
import { getFeetInchesFromInches } from '../../../../../../shared/utils/mathUtils/getFeetInchesFromInches/getFeetInchesFromInches';

type GeneralInfoRowProps = {
  customerGeneralInfo: CustomerGeneralInfo;
};

const GeneralInfoRow = ({ customerGeneralInfo }: GeneralInfoRowProps) => {
  const { bmr, gender, height, weight, age } = customerGeneralInfo;

  const { value: heightValue } = getFeetInchesFromInches(height);

  return (
    <Paper variant="roundedBox" className={classes.box}>
      <InfoCell title="Basal Metabolic Rate (BMR)" info={bmr} adornment="kcal / day" />
      <InfoCell title="Gender" info={gender} />
      <InfoCell title="Age" info={age} />
      <InfoCell title="Height" info={heightValue} />
      <InfoCell title="Weight" info={weight} />
    </Paper>
  );
};

export { GeneralInfoRow };
